module.exports = __webpack_public_path__ + "static/hero-guard-green-03fd3b74248a62d5b7df2365fe971f35.jpg";